import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoalSteps = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "svgexport-11 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M28 17.3333C28 23.9608 22.6274 29.3333 16 29.3333C9.37259 29.3333 4 23.9608 4 17.3333C4 10.7059 9.37259 5.33333 16 5.33333C22.6274 5.33333 28 10.7059 28 17.3333Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M16 5.33333V2.66667",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M13.3333 2.66667H18.6667",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M9.33333 16L20 12.6667L16.6667 23.3333L14.6667 18L9.33333 16Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgGoalSteps;
